"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));
var _InputLabel = _interopRequireDefault(require("@material-ui/core/InputLabel"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _Select = _interopRequireDefault(require("@material-ui/core/Select"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));
var _ProductDetailContext = _interopRequireDefault(require("../../../../ProductDetail/context/ProductDetailContext"));
var _getSelectableOption = _interopRequireDefault(require("../../../../ProductDetail/utils/getSelectableOption"));
var _de = _interopRequireDefault(require("../../../../locals/de.json"));
var _en = _interopRequireDefault(require("../../../../locals/en.json"));
var _it = _interopRequireDefault(require("../../../../locals/it.json"));
var _Select2 = _interopRequireDefault(require("./Select.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Select = _ref => {
  let {
    identifier,
    label,
    lang,
    loading,
    options = [],
    value = ""
  } = _ref;
  const {
    attributes,
    combinationValues,
    setCombinationValues
  } = (0, _react.useContext)(_ProductDetailContext.default);
  const css = (0, _Select2.default)();
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  (0, _react.useEffect)(() => {
    if (!value) {
      const option = (0, _getSelectableOption.default)(attributes, identifier);
      if ((0, _isEmpty.default)(option)) return;
      handleChange(identifier, option === null || option === void 0 ? void 0 : option.id);
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attributes, identifier, value]);
  const checkIfSelectable = (0, _react.useCallback)(value => {
    var _options$find;
    return options === null || options === void 0 || (_options$find = options.find(_ref2 => {
      let {
        id
      } = _ref2;
      return id === value;
    })) === null || _options$find === void 0 ? void 0 : _options$find.selectable;
  }, [options]);
  const sortedOptions = (0, _react.useMemo)(() => {
    return options === null || options === void 0 ? void 0 : options.sort((a, b) => b.selectable - a.selectable);
  }, [options]);
  const handleChange = (identifier, value) => {
    const _combinationValues = JSON.parse(JSON.stringify(combinationValues));
    if (!checkIfSelectable(value)) {
      for (const key of Object.keys(attributes)) {
        delete _combinationValues[key];
      }
    }
    delete _combinationValues.combinationID;
    _combinationValues[identifier] = value;
    setCombinationValues(_combinationValues);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.select, "mco-shop-combination-selection__select")
  }, /*#__PURE__*/_react.default.createElement(_FormControl.default, {
    fullWidth: true,
    variant: "outlined"
  }, /*#__PURE__*/_react.default.createElement(_InputLabel.default, {
    shrink: true
  }, /*#__PURE__*/_react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: label
    }
  })), /*#__PURE__*/_react.default.createElement(_Select.default, {
    displayEmpty: true,
    error: !loading && !value,
    label: /*#__PURE__*/_react.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: label
      }
    }),
    name: identifier,
    notched: true,
    value: value,
    MenuProps: {
      classes: {
        paper: css.menuPaper
      },
      disableScrollLock: true
    },
    onChange: e => handleChange(identifier, e.target.value)
  }, loading && !value && /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
    value: ""
  }, "Loading..."), sortedOptions === null || sortedOptions === void 0 ? void 0 : sortedOptions.map((option, index) => {
    const {
      id,
      selectable = true,
      title
    } = option;
    return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
      className: (0, _clsx.default)({
        [css.disabled]: !selectable
      }),
      key: index,
      value: id
    }, title);
  }))), !loading && !value && /*#__PURE__*/_react.default.createElement("p", {
    className: (0, _clsx.default)(css.errorMessage, "mco-shop-combination-selection__error-message")
  }, /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.productDetail.messages.errors.select",
    l: l,
    label: label
  })));
};
var _default = exports.default = Select;